var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Assignment } from "./Assignment";
var AssignmentSingle = /** @class */ (function (_super) {
    __extends(AssignmentSingle, _super);
    function AssignmentSingle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(AssignmentSingle.prototype, "Name", {
        get: function () {
            if (this.Items.length < 1) {
                return "";
            }
            return this.Items[0].Name;
        },
        set: function (v) {
            if (this.Items.length < 1) {
                return;
            }
            this.Items[0].Name = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(AssignmentSingle.prototype, "ResultId", {
        get: function () {
            if (this.Items.length < 1) {
                return "";
            }
            return this.Items[0].ResultId;
        },
        set: function (v) {
            if (this.Items.length < 1) {
                return;
            }
            this.Items[0].ResultId = v;
        },
        enumerable: true,
        configurable: true
    });
    return AssignmentSingle;
}(Assignment));
export { AssignmentSingle };



// WEBPACK FOOTER //
// ./src/app/shared/models/AssignmentSingle.ts.pre-build-optimizer.js